module.exports = __webpack_public_path__ + "img/mobile-assess-logos.5fa2921.png";